export const PASSWORD_RULES_TEXT =
  "8 caractères minimum, 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial.";

export const validatePassword = (password) => {
  if (!password || password.length < 8) return "Le mot de passe doit contenir au moins 8 caractères.";
  if (!/[a-z]/.test(password)) return "Le mot de passe doit contenir au moins une minuscule.";
  if (!/[A-Z]/.test(password)) return "Le mot de passe doit contenir au moins une majuscule.";
  if (!/\d/.test(password)) return "Le mot de passe doit contenir au moins un chiffre.";
  if (!/[^A-Za-z0-9]/.test(password)) return "Le mot de passe doit contenir au moins un caractère spécial.";
  return "";
};
